import { Box } from '@mui/material'
import React, { useRef, useState, useCallback } from 'react'
import { Field } from 'formik'
import api from 'api'
import TextField from 'components/Common/TextField'
import { useOnClickOutside } from 'hooks'
import { AccountFormField } from 'components/Common/AccountFormLayout'

const sx = {
  codes: {
    position: 'relative',
    top: -10,
    width: '100%',
    padding: 10,
    zIndex: 1000,
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    overflowY: 'auto',
    maxHeight: 250,
    fontSize: '14px',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    marginTop: '7px'
  },
  span: {
    padding: 8,
    cursor: 'pointer',
    display: 'block',
    color: '#66668F',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: '#F4F4F7',
    },
  },
}

const CodeDropdown = ({ codes, setValue, dropToDefault, style, isCountry, isFullStateNameSearch }) => {
  const action = item => {
    dropToDefault([])
    setValue(item)
  }
  if (codes.length === 0) return null
  if (isFullStateNameSearch) {
    return (
      <Box className={sx.codes} style={style}>
        {codes.map(item => (
          <Box component="span" onClick={() => action(item)} sx={sx.span} key={item.state_code}>
            {item.state_display_name}
          </Box>
        ))}
      </Box>
    )
  }
  return (
    <Box sx={sx.codes} style={style}>
      {codes.map(item => (
        <Box component="span" onClick={() => action(item)} sx={sx.span} key={item}>
          {item}
        </Box>
      ))}
    </Box>
  )
}

export const CodeListDropdown = ({
  name,
  isCountry,
  onChange,
  setFieldValue,
  helperText,
  placeholder,
  label,
  bgwhite,
  onKeyPress,
  isFullStateNameSearch,
  customHintStyle = {},
  setStateCode = () => { },
  isFocusResetSate = true,
  setFieldError,
  setFieldTouched,
  setErrors,
  errors,
  ...rest
}) => {
  const [codes, setCodes] = useState([])
  const ref = useRef(null)

  useOnClickOutside(ref, () => setCodes([]))

  const getCodes = async search => {
    const res = isFullStateNameSearch
      ? await api.getStateName({ state: search })
      : isCountry
        ? await api.getCountriesCodes(search)
        : await api.getStateCodes(search)
    if (isFullStateNameSearch) {
      return setCodes(res?.details || [])
    }
    setCodes(res)
  }

  const setValueByName = useCallback(
    value => {
      if (isFullStateNameSearch) {
        setFieldValue(name, value?.state_display_name)
        setStateCode(value?.state_code)
        setFieldTouched('businessStateCode')
        setFieldValue('businessStateCode', value?.state_code)
        return
      }
      setFieldValue(name, value)
    },
    [name, setFieldValue, isFullStateNameSearch, setStateCode, setFieldTouched],
  )

  return (
    //@ts-ignore
    <div style={{ position: 'relative' }} ref={ref}>
      <AccountFormField style={{ height: 'unset' }}>
        <Field name={name}>
          {({ field, meta }) => (
            <TextField
              {...field}
              label={label}
              fullWidth
              bgwhite={bgwhite}
              placeholder={placeholder}
              onKeyPress={e => onKeyPress(e, isFullStateNameSearch)}
              error={Boolean(meta.touched && meta.error)}
              helperText={helperText}
              isSelect
              onClickSelect={() => {
                getCodes('')
              }}
              onChange={e => {
                onChange(e, setFieldValue, getCodes)
                if (isFullStateNameSearch) {
                  setFieldTouched('businessStateCode')
                  setFieldValue('businessStateCode', '')
                }
              }}
              onFocus={() => {
                if (isFullStateNameSearch) getCodes('')
                if (!isFocusResetSate) return
                getCodes('')
                setFieldValue(name, '')
              }}
              {...rest}
            />
          )}
        </Field>
      </AccountFormField>
      <CodeDropdown
        setValue={setValueByName}
        dropToDefault={setCodes}
        codes={codes}
        isCountry={isCountry}
        style={customHintStyle}
        isFullStateNameSearch={isFullStateNameSearch}
      ></CodeDropdown>
    </div>
  )
}
